import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const insertCustomModule = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCustomModuleById = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModule = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleId = async (moduleId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}/${moduleId}/${pageId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCustomModuleLibrary = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE}`, {
      data: { libIds: ids },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const insertCustomModuleGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleGroup = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleGroupId = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editCustomModuleGroupById = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCustomModuleGroup = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, {
      data: { groupIds: ids },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addLibraryToCustomModuleGroup = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateCustomModuleLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.DUPLICATE_CUSTOM_MODULE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async () => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.CUSTOM_MODULE.DOWNLOAD_CUSTOM_TABLE_SAMPLE}`, null, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const activeInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_STATUS}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadCMImageS3 = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.UPLOAD_CM_IMAGE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCMImageFromS3 = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.CM_IMAGE_DELETE}`, { data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getNewPageId = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.GET_NEW_PAGEID}`, { ...data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteCustomModuleLibraryPage = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_MODULE.DELETE_PAGE_ID}`, {
      data: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleList = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_LIST}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateLibraryPageSequence = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_REARRANGE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleContentPage = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_CONTENT_PAGE}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPageControls = async (customModuleLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_CONTROLS}/${customModuleLibId}/${pageId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getSrcPages = async (customModuleLibId, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGES}/${customModuleLibId}`, { params: { ...params } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getDependentControlsList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_DEPENDENT_CONTROLS}/${data}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCustomModuleContentData = async (moduleId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_CONTENT_DATA}/${moduleId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getPageCalculationControls = async (customModuleLibId, pageId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_MODULE.CUSTOM_MODULE_PAGE_CALCULATION_CONTROLS}/${customModuleLibId}/${pageId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const previewTemplateService = async (data) => {
  console.log('🚀 ~ previewTemplateService ~ data:', data);
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_MODULE.PREVIEW_CUSTOM_MODULE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInactiveCustomModuleGroup = async (data) => {
  try {
    const res = await apiClient.put(`${apiEndpoint}${API.CUSTOM_MODULE.COMMON_CUSTOM_MODULE_GROUP_STATUS}`, data);
    if (res.code === 200) {
      return res;
    }
    return false;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const listControlTypes = async (params = {}) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.CONTROL_TYPES}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getControlTypeById = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.CONTROL_TYPE_BY_ID}${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createControlType = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_CANVAS.CONTROL_TYPES}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateControlType = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_CANVAS.CONTROL_TYPE_BY_ID}${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteControlType = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_CANVAS.CONTROL_TYPE_BY_ID}${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const listModules = async (params = {}) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULES}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const listAllControls = async (params = {}) => {
  try {
    const response = await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.CONTROLS}`, { params });

    if (params.controltype && response?.data) {
      const filteredData = response.data;
      return {
        ...response,
        data: filteredData,
      };
    }

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getModuleById = async (id, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULE_BY_ID}${id}`, params ? { params } : undefined);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getModuleDetailsWithSourceValues = async (id, devOrderId = null, timezone = 'UTC') => {
  try {
    const params = {};
    if (devOrderId) {
      params.devOrderId = devOrderId;
    }
    if (timezone) {
      params.timezone = timezone;
    }
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULE_DETAILS}${id}/details`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getLibraryTabDetails = async (moduleId, tabIndex, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.GET_TAB_DETAILS}${moduleId}/tabs/${tabIndex}`, params ? { params } : undefined);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createModule = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULES}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateModule = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULE_BY_ID}${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteModule = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULE_BY_ID}${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createOrUpdateDevelopmentOrderModule = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DEVELOPMENT_ORDERS_MODULES.CREATE_OR_UPDATE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const partialUpdateDevelopmentOrderModule = async (moduleId, data) => {
  try {
    return await apiClient.patch(`${apiEndpoint}${API.DEVELOPMENT_ORDERS_MODULES.PARTIAL_UPDATE}/${moduleId}/partial-update`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAvailableModulesForDevOrder = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDERS_MODULES.GET_AVAILABLE_MODULES}${devOrderId}/available-modules`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getModuleDataWithSource = async (devOrderId, moduleId, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDERS_MODULES.GET_MODULE_DATA_WITH_SOURCE}${devOrderId}/modules/${moduleId}/data`, params ? { params } : undefined);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTabDetails = async (devOrderId, moduleId, tabId, params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDERS_MODULES.GET_TAB_DETAILS}${devOrderId}/modules/${moduleId}/tabs/${tabId}`, params ? { params } : undefined);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMultipleModules = async (ids) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULES}`, {
      data: { ids },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateModule = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_CANVAS.DUPLICATE_MODULE}${id}/duplicate`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateControl = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_CANVAS.DUPLICATE_CONTROL}${id}/duplicate`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveModuleIcon = async (moduleId, s3Key) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_CANVAS.MODULE_ICON}${moduleId}/icon`, {
      s3Key,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Fetches one page of a library table's rows.
 * @param {string} moduleId - Library module id
 * @param {string} tabId - Tab holding the table
 * @param {string} subSectionId - Sub-section holding the table
 * @param {number} offset - Index of the first row
 * @param {number} limit - Rows to fetch
 * @returns {Promise<object>} API response with { rows, offset, totalRows }
 */
export const getLibraryTableRows = async (moduleId, tabId, subSectionId, offset, limit) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_CANVAS.GET_TAB_DETAILS}${moduleId}/tabs/${tabId}/tables/${subSectionId}/rows`, { params: { offset, limit } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Fetches one page of a product module table's rows.
 * @param {string} devOrderId - Product id
 * @param {string} moduleId - Product module id or library module id
 * @param {string} tabId - Tab holding the table
 * @param {string} subSectionId - Sub-section holding the table
 * @param {number} offset - Index of the first row
 * @param {number} limit - Rows to fetch
 * @returns {Promise<object>} API response with { rows, offset, totalRows }
 */
export const getProductTableRows = async (devOrderId, moduleId, tabId, subSectionId, offset, limit) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDERS_MODULES.GET_TAB_DETAILS}${devOrderId}/modules/${moduleId}/tabs/${tabId}/tables/${subSectionId}/rows`, {
      params: { offset, limit },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
